import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PresupuestoGuardarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description guardar persupuesto
   * @params body
   */
  postBudgetSave(body: any): Observable<object> {
    const httpOptions: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.presupuestoGuardar.name,
      body,
      httpOptions
    );
  }

}
